import hex_is_light from "../api/is_light_color";
import generatePalette from "../api/palette_generator";

export function handleDocumentValues(docu,id,color){
            const colors = generatePalette(color)
            switch(id){
                case "primary":
                    
                    for (let key in colors){
                        docu.documentElement.style.setProperty(`--primary-${key}`, colors[key]);
                        console.log(`--primary-${key}`, colors[key])
                    }
                    break;
                case "secondary":
                    for (let key in colors){
                        docu.documentElement.style.setProperty(`--secondary-${key}`, colors[key]);
                        console.log(`--secondary-${key}`, colors[key])
                    }
                    break;
                case "sidebar":
                    docu.documentElement.style.setProperty(`--sidebar-background-color`, color)     
                    docu.documentElement.style.setProperty(`--nav-item-color`, hex_is_light(color)?"var(--grey-800)":"var(--grey-50)");     
                    break;
                 case "background":
                    docu.documentElement.style.setProperty(`--body-background-color`, color);
                    docu.documentElement.style.setProperty(`--title-color`, hex_is_light(color)?"black":"white");
                 case "borders2":
                    docu.documentElement.style.setProperty(`--divider-border-color`, color);
                   break;
                 case "borders":
                    docu.documentElement.style.setProperty(`--border-color`, color);
                  break;
                 case "cards":
                    docu.documentElement.style.setProperty(`--card-background-color`, color);
                  //   docu.documentElement.style.setProperty(`--standard-text-color`, hex_is_light(color)?"black":"white");
                    docu.documentElement.style.setProperty(`--standard-text-color-light`, hex_is_light(color)?"grey":"light-grey");
                  //   docu.documentElement.style.setProperty(`--topbar-background-color`, color);
                    break;
                 case "text":
                    
                    docu.documentElement.style.setProperty(`--standard-text-color`, color);
                    docu.documentElement.style.setProperty(`--standard-text-color-light`, hex_is_light(color)?"grey":"light-grey");
                    // document.documentElement.style.setProperty(`--white`, color);
                    break;
                 case "sub_text":
                    
                    docu.documentElement.style.setProperty(`--standard-text-color-light`, color);
                    
                    // document.documentElement.style.setProperty(`--white`, color);
                    break;
                 case "card_text":
                    
                    docu.documentElement.style.setProperty(`--card-title-color`, color);
                    docu.documentElement.style.setProperty(`--card-description-color`, hex_is_light(color)?"grey":"light-grey");
                    // document.documentElement.style.setProperty(`--white`, color);
                    break;
                 case "topbar":
                    
                    docu.documentElement.style.setProperty(`--topbar-background-color`, color);
                    
                    // document.documentElement.style.setProperty(`--white`, color);
                    break;
                 case "border_radius":
                    
                    docu.documentElement.style.setProperty(`--br-scale`, parseInt(color));
                    
                    // document.documentElement.style.setProperty(`--white`, color);
                    break;
                 case "sidebar_style":
                  if(docu.getElementsByClassName('sidebar').length > 0){
                     if(color == 2){
                     const sidebarText = docu.getElementsByClassName('phone-sidebar-text')
                    const navItem = docu.getElementsByClassName('nav-item')
                    const sidebar = docu.getElementsByClassName('sidebar')[0]
                    for (var i = 0 ;i<sidebarText.length; i++){
                        sidebarText[i].style.display = "none"
                        navItem[i].style.width = "unset"
                    }
                    sidebar.style.width = "min-content"
                  
                    }else{
                     const sidebarText = docu.getElementsByClassName('phone-sidebar-text')
                    const navItem = docu.getElementsByClassName('nav-item')
                    const sidebar = docu.getElementsByClassName('sidebar')[0]
                    for (var i = 0 ;i<sidebarText.length; i++){
                        sidebarText[i].style.display = "unset"
                        navItem[i].style.width = "100%"
                    }
                    sidebar.style.width = "15%"
                    }
               
                  }
                   
                  //   sidebarText.forEach(sidebar => {
                  //    sidebar.style.display = "none"
                  //   });
                  
                    
                    // document.documentElement.style.setProperty(`--white`, color);
                    break;
                    default:
                 }
    
        }